export default "__VITE_ASSET__c1c8684c__"